import theme from '../../../lib/theme';
import { ContentBlockProps } from './ContentBlock';

const { layouts, scale, media, colors } = theme;

export default ({}: ContentBlockProps) => ({
  container: {},

  title: {
    margin: `0 !important`,
    padding: `0 !important`,
  },

  subtitle: {
    margin: `0 !important`,
    padding: `0 !important`,
  },

  content: {
    margin: 0,
  },

  div1: {
    padding: scale.xxxxl,
    margin: scale.xxxxs,
  },
  div2: {
    padding: scale.xxxl,
    margin: scale.xxxs,
  },
  div3: {
    padding: scale.xxl,
    margin: scale.xxs,
  },
  div4: {
    padding: scale.xl,
    margin: scale.xs,
  },
  div5: {
    padding: scale.l,
    margin: 0,
  },
  div6: {
    padding: scale.m,
    margin: 0,
  },
  div7: {
    padding: scale.s,
    margin: 0,
  },
});
